// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics"; 

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBBr39ZrxX7PqqAUqhhA8KjqgNP-oIKGdg",
  authDomain: "readerum-com.firebaseapp.com",
  projectId: "readerum-com",
  storageBucket: "readerum-com.appspot.com",
  messagingSenderId: "884579085759",
  appId: "1:884579085759:web:5f470c2f65c7525738450a",
  measurementId: "G-YJM5TB7FX7"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa el servicio de autenticación
const auth = getAuth(app);

// Inicializa Google Analytics
const analytics = getAnalytics(app);

export { auth, analytics }; // Exporta tanto auth como analytics



